import { getLcn } from '~/utils/labeled-classnames';

export const Branding = () => {
  const lcn = getLcn({
    branding: 'flex flex-col gap-2 items-center w-full p-4',
  });

  return (
    <div className={lcn.branding}>
      <div className="text-lg font-semibold">
        Ben Lieb
      </div>
    </div>
  );
};
